<div class="ai-loading-overlay" [class.hidden]="!isAiLoading">
    <div class="ai-loading-content" *ngIf="importState?.status === 'waiting'">
        <p translate>Salesflare is automatically mapping your data to the right fields ✨</p>
    </div>
</div>

<sfx-toolbar disableBack>
    <div data-layout="row" data-layout-align="start center" data-layout-gap="16px">
        <mat-icon track-id="close" fontSet="salesflare" fontIcon="sf-icon-close" class="button" (click)="back()"></mat-icon>
        {{ 'Map your {{type}} data to the Salesflare system' | translate: {type: importState?.type} }}
    </div>
</sfx-toolbar>

<mat-divider *ngIf="media.isActive('gt-sm')">

</mat-divider>

<sfx-content class="import-map" data-layout="column" data-layout-align="start center">

    <div class="infobox"><p [innerHTML]="getInfoboxText()"></p><a href="https://howto.salesflare.com/en/articles/1245725-how-do-i-import-my-data-in-salesflare" target="_blank" rel="noopener" translate>Read more</a></div>

    <table class="import-table" [class.has-date-formats]="hasDateFormatSelects" mat-table [dataSource]="datasource">

        <ng-container matColumnDef="file">
            <th mat-header-cell *matHeaderCellDef class="import-table-header import-table-row-label" translate>File headers:</th>
            <td mat-cell *matCellDef="let sample; let idx = index" class="import-table-field-sample import-table-row-label">Sample {{ idx + 1}}</td>
            <td mat-footer-cell *matFooterCellDef class="import-table-field-sample import-table-row-label">...</td>
        </ng-container>

        <ng-container matColumnDef="file_description">
            <th mat-header-cell *matHeaderCellDef class="import-table-field-select import-table-row-label" translate>Salesflare field:</th>
        </ng-container>

        <ng-container *ngFor="let header of headers; let i = index;">
            <ng-container [matColumnDef]="header + '_description'">
                <th mat-header-cell *matHeaderCellDef>
                    <div class="select-container">
                        <mat-select [(ngModel)]="chosenHeaders[i]" [aria-label]="'select-' + header" (ngModelChange)="updateMapping(i)"
                                    [compareWith]="compareHeaders" [placeholder]="'Select Salesflare field' | translate" class="select-header" panelWidth="" [disabled]="disabledSelect"
                        >
                            <mat-option>
                                <span class="default-column" translate>
                                    Select Salesflare field
                                </span>
                            </mat-option>
                            <mat-option
                                    *ngFor="let heading of sfHeader; let idx = index;" [value]="heading"
                            >
                                {{ heading.name }}{{ heading.required? '*': ''}}
                            </mat-option>
                        </mat-select>
                        <mat-select *ngIf="isAmbiguousDateField(i)" [(ngModel)]="dateFields[headers[i]].chosenFormat" [aria-label]="'select-date-format' + header" (ngModelChange)="updateDateFormat()"
                                    [placeholder]="'Select date format' | translate" class="select-date-format" panelWidth="" [disabled]="disabledSelect"
                        >
                            <mat-option
                                    *ngFor="let format of dateFields[headers[i]].formats;" [value]="format"
                            >
                                {{ format }}
                            </mat-option>
                        </mat-select>
                    </div>
                </th>
            </ng-container>
            <ng-container [matColumnDef]="header">
                <th mat-header-cell *matHeaderCellDef class="import-table-header">{{ header }}</th>
                <td mat-cell *matCellDef="let sample" class="import-table-field-sample import-table-field-sample-value">{{ sample[header] }}</td>
                <td mat-footer-cell *matFooterCellDef class="import-table-field-sample">...</td>
            </ng-container>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-header-row *matHeaderRowDef="secondaryHeaders"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
    </table>

    <div>
        <p *ngIf="showCreateAccountCheckbox" 
           [matTooltip]="'Map \'account name\' to link contacts to accounts, optionally creating accounts if they don\'t exist.' | translate">
          <mat-checkbox class="read-more-checkbox" [disabled]="!enableCreateAccountCheckbox" [(ngModel)]="createAccountIfNotExists">
            <span translate>
              Create an account if it doesn't exist yet.
            </span>
          </mat-checkbox>
          <a class="read-more-link" href="http://howto.salesflare.com/en/articles/5790347-can-i-create-accounts-on-a-contact-import"
             target="_blank" rel="noopener" translate>Read more.</a>
        </p>
        
        <p *ngIf="isFindEmailEnabled && showFindEmailCheckbox" 
           [matTooltip]="'Map \'first name\' and \'last name\' (or \'full name\') and \'account website\' (or \'account name\') first to be able to find email addresses.' | translate">
          <mat-checkbox class="read-more-checkbox" [disabled]="!enableFindEmailCheckbox" [(ngModel)]="findEmailIfNotExists">
            <span translate>
              Find email address when none is specified (uses credits).
            </span>
          </mat-checkbox>
          <a class="read-more-link" href="https://howto.salesflare.com/en/articles/5797397-can-i-find-email-addresses-for-contacts-in-salesflare"
             target="_blank" rel="noopener" translate>Read more.</a>
        </p>
        
        <p *ngIf="importState?.type === 'account'">
          <mat-checkbox [(ngModel)]="updateAccountIfExists" [attr.aria-label]="'update account if exists' | translate">
            <span translate>Update accounts if they have the same name (instead of duplicating)</span>
          </mat-checkbox>
        </p>
      </div>      
    <p [innerHTML]="getImportTagText()"></p>
    <div class="tooltip-disabled-button-wrapper">
        <button class="start-import-button"
                mat-raised-button [disabled]="isRestricted || disableImportButton || needsToSelectDateFormat" (click)="startImport()" color="primary"
                [matTooltip]="'You can\'t start an import because your team is restricted.' | translate" [matTooltipDisabled]="!isRestricted"
        >
        <span translate>
            Start import
        </span>
        </button>
    </div>
</sfx-content>
